/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';
import { replaceDefaultBrandName } from 'shared/helpers/branding';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "Chatwoot" in text with the installation name from global config
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = text => {
    const brandName =
      globalConfig.value?.brandName || globalConfig.value?.installationName;

    return replaceDefaultBrandName(text, brandName);
  };

  return {
    replaceInstallationName,
  };
}
